<template>
	<div id="equipmentDetail">
		<DetailCard v-loading="loading" :config="config"></DetailCard>
		<DcardNott v-show="isBindMc" :config="mconfig"></DcardNott>
		<div class="gttcard">
			<p class="gttcard-tt">{{ $t("terminal.device_detail") }}</p>
			<div class="gttcard-in">
				<el-row>
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.device_addtime") }}：</label>
						<label class="eddtcolor">{{baseInfo.createTime}}</label>
					</el-col>
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.device_acttime") }}：</label>
						<label class="eddtcolor">{{baseInfo.activateTime}}</label>
					</el-col>
				</el-row>
				<el-row class="edmg16">
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.last_online") }}：</label>
						<label class="eddtcolor">{{baseInfo.lastOnlineTime}}</label>
					</el-col>
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.last_offline") }}：</label>
						<label class="eddtcolor">{{baseInfo.lastOfflineTime}}</label>
					</el-col>
					<el-col :span="8" v-if="baseInfo.lineStatus != $t('app_online')">
						<label class="edttcolor">{{ $t("terminal.offline_time") }}：</label>
						<label class="eddtcolor">{{calOfflCount}}</label>
					</el-col>
				</el-row>

				<div class="edmg16" style="width:100%;height:1px;background:rgba(233,233,233,1);"></div>

				<el-row class="edmg16">
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.device_status") }}：</label>
						<label class="eddtcolor">{{baseInfo.lineStatus}}</label>
					</el-col>
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.current_network") }}：</label>
						<label class="eddtcolor">{{baseInfo.nettype}}</label>
					</el-col>
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.internet_signal") }}：</label>
						<label class="eddtcolor">{{baseInfo.netsignal}}</label>
					</el-col>
				</el-row>
				<el-row class="edmg16">
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.device_power") }}：</label>
						<label class="eddtcolor">{{baseInfo.battery}}%</label>
					</el-col>
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.hardware_version") }}：</label>
						<label class="eddtcolor">{{baseInfo.hwver}}</label>
					</el-col>
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.wifi_version") }}：</label>
						<label class="eddtcolor">{{baseInfo.appVer}}</label>
					</el-col>
				</el-row>
				<el-row class="edmg16">
					<el-col :span="8">
						<!-- <label class="edttcolor">系统音频库版本：</label>
            <label class="eddtcolor">{{baseInfo.sysAudioVer}}</label> -->
						<label class="edttcolor">{{ $t("terminal.GPRS_system_version") }}：</label>
						<label class="eddtcolor">{{baseInfo.gprsSysVer}}</label>
					</el-col>
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.user_audio_version") }}：</label>
						<label class="eddtcolor">{{baseInfo.usrAudioVer}}</label>
					</el-col>
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.GPRS_firmware_version") }}：</label>
						<label class="eddtcolor">{{baseInfo.gprsAppVer}}</label>
					</el-col>
				</el-row>
				<el-row class="edmg16" vvf="baseInfo.terminalVersion == 'GPRS+Wi-Fi'">
					<el-col :span="8">
						<label class="edttcolor">IMEI：</label>
						<label class="eddtcolor">{{baseInfo.imei}}</label>
					</el-col>
					<el-col :span="8">
						<label class="edttcolor">IMSI：</label>
						<label class="eddtcolor">{{baseInfo.imsi}}</label>
					</el-col>
					<el-col :span="8">
						<label class="edttcolor">ICCID：</label>
						<label class="eddtcolor">{{baseInfo.iccid}}</label>
					</el-col>
				</el-row>
				<el-row class="edmg16">
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.longitude") }}：</label>
						<label class="eddtcolor">{{baseInfo.gpsLng}}</label>
					</el-col>
					<el-col :span="8">
						<label class="edttcolor">{{ $t("terminal.latitude") }}：</label>
						<label class="eddtcolor">{{baseInfo.gpsLat}}</label>
					</el-col>
				</el-row>
			</div>
		</div>
		<el-dialog @close="closeDia" style="min-width: 1140px;" class="gstdia" :title="$t('terminal.edit_device')" :visible.sync="showDia">
			<el-form :model="tform" :rules="rules" ref="ruleForm">
				<el-form-item v-show="$isAdminType()" :label="$t('terminal.device_sn')" :label-width="$formlbWidth" prop="deviceid">
					<el-input v-model="tform.deviceid" autocomplete="off" :disabled="0==0"></el-input>
				</el-form-item>
				<el-form-item v-show="$isAdminType()" :label="$t('terminal.device_model_2')" :label-width="$formlbWidth" prop="productKey">
					<Model :config="editModel"></Model>
				</el-form-item>
				<el-form-item :label="$t('terminal.device_model')" :label-width="$formlbWidth" prop="model">
					<el-select v-model="tform.model" :placeholder="$t('app_select')" style="width: 100%;">
						<el-option v-for="(item,index) in model_type_list" :key="index" :label="item.name" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('terminal.device_name')" :label-width="$formlbWidth" prop="devicename">
					<el-input v-model="tform.devicename" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item v-show="$isAdminType()" :label="$t('terminal.app_distributor')" :label-width="$formlbWidth" prop="merchant">
					<Merchant :config="editMc"></Merchant>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button type="primary" @click="submit">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">
      </div>-->
		</el-dialog>
		<ReceiptRec :config="prconfig"></ReceiptRec>
	</div>
</template>


<style>
	.edmg16 {
		margin-top: 16px;
	}

	.edttcolor {
		font-size: 14px;
		color: rgba(0, 0, 0, 0.85);
	}

	.eddtcolor {
		font-size: 14px;
		color: rgba(0, 0, 0, 0.65);
	}
</style>


<script>
	import DetailCard from "@/components/DetailCard.vue";
	import DcardNott from "@/components/DcardNott.vue";
	import ReceiptRec from "@/components/PlayrcAndLog.vue";
	import Merchant from "@/components/Merchant.vue";
	import Model from "@/components/Model.vue";
	import dayjs from 'dayjs'

	export default {
		data() {
			return {
				model_type_list: [{
						id: 0,
						name: "KS8303",
						value: "KS8303",
					},
					{
						id: 1,
						name: "ZTMD711",
						value: "ZTMD711",
					},
					{
						id: 2,
						name: "ZTMD715",
						value: "ZTMD715",
					},
					{
						id: 3,
						name: "KS8303 Plus",
						value: "KS8303 Plus",
					}
				
				],
				isBindMc: false,
				prconfig: "",
				mconfig: "",
				loading: false,
				config: "",
				baseInfo: {},
				page: 1,
				total: 0,
				showDia: false,
				editModel: {},
				editMc: {},
				tform: {
					deviceid: "",
					devicename: "",
					productKey: "",
					model:"",
					merchant: ""
				},
				tformVal: {
					deviceid: "",
					devicename: "",
					productKey: "",
					merchant: "",
					model:"",
				},
				rules: {
					deviceid: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					devicename: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					productKey: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					model: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					merchant: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}]
				}
			};
		},
		components: {
			DetailCard,
			ReceiptRec,
			Merchant,
			Model,
			DcardNott
		},
		computed: {
			calOfflCount() {
				// dayjs(this.baseInfo.lastOnlineTime).diff(dayjs(this.baseInfo.lastOfflineTime))
				var sec = dayjs().diff(dayjs(this.baseInfo.lastOfflineTime), 'second')
				return this.formatSeconds(sec)
			},
			isEdit() {
				var fun = () => {
					this.showDia = true;
					this.setMcCtr(this.tformVal.merchant);
					this.setProCtr(this.tformVal.productKey);
					this.tform.deviceid = this.tformVal.deviceid;
					this.tform.productKey = this.tformVal.productKey;
					this.tform.devicename = this.tformVal.devicename;
					this.tform.merchant = this.tformVal.merchant;
					this.tform.model = this.tformVal.model;
					console.log(this.tform)
				}
				return this.$isAdminType() ? fun : ''
			}
		},
		methods: {
			formatSeconds(s) {
				// var theTime = parseInt(value);// 秒
				// var middle= 0;// 分
				// var hour= 0;// 小时
				// if(theTime > 60) {
				//     middle= parseInt(theTime/60);
				//     theTime = parseInt(theTime%60);
				//     if(middle> 60) {
				//         hour= parseInt(middle/60);
				//         middle= parseInt(middle%60);
				//     }
				// }
				// var result = ""+parseInt(theTime)+"秒";
				// if(middle > 0) {
				//     result = ""+parseInt(middle)+"分"+result;
				// }
				// if(hour> 0) {
				//     result = ""+parseInt(hour)+"时"+result;
				// }
				// return result;
				var day = Math.floor(s / (24 * 3600)); // Math.floor()向下取整 
				var hour = Math.floor((s - day * 24 * 3600) / 3600);
				var minute = Math.floor((s - day * 24 * 3600 - hour * 3600) / 60);
				var second = s - day * 24 * 3600 - hour * 3600 - minute * 60;
				if (day > 0) {
					return day + this.$t("app_day") + hour + this.$t("app_hour") + minute + this.$t("app_minute") + second + this.$t("app_second");
				} else if (hour > 0) {
					return hour + this.$t("app_hour") + minute + this.$t("app_minute") + second + this.$t("app_second");
				} else if (minute > 0) {
					return minute + this.$t("app_minute") + second + this.$t("app_second");
				} else {
					return second + this.$t("app_second");
				}
			},
			setMcCard(data) {
				this.mconfig = {
					title: this.$t("merchant.store_name") + data.merchantName,
					rd1: [{
							tt: this.$t("merchant.merchant_id"),
							ct: data.merchantId
						},
						{
							tt: this.$t("terminal.app_contactPhone"),
							ct: data.merchantPhone
						},
						// {tt:'绑定设备数量', ct: data.deviceNum},
						{
							tt: this.$t("merchant.merchant_num"),
							ct: data.merchantNo
						},
						{
							tt: this.$t("merchant.merchant_can_num"),
							ct: data.channelNo
						}
					],
					rd2: [{
							tt: this.$t("merchant.merchant_name"),
							ct: data.contacts
						},
						// {tt:'渠道商', ct: data.agentName},
						{
							tt: this.$t("terminal.merchant_add_time"),
							ct: data.createTime
						},
						{
							tt: this.$t("terminal.sub_organization"),
							ct: data.subMerchant
						}
					],
					rd3: [{
							tt: this.$t("terminal.broad_num"),
							ct: data.logplayNum
						},
						{
							tt: "",
							ct: ""
						}
					],
					edit: ""
				};
			},
			getDetail() {
				var deviceid = this.$route.query.deviceid;
				var agentId = this.$route.query.agentId;
				//console.log(JSON.stringify('get detail id = '+deviceid))
				this.$equipDetail(
					1,
					100,
					deviceid,
					res => {
						//console.log('get detail '+JSON.stringify(res))
						this.setCard(res.data);
						if (res.data.merchant) {
							this.isBindMc = true;
							this.setMcCard(res.data.merchant);
						}
						this.baseInfo = res.data;
						// this.setBaseInfo(res.data)
						console.log('lng', this.baseInfo)
						this.tformVal.deviceid = res.data.deviceid;
						this.tformVal.productKey = res.data.productkey;
						this.tformVal.devicename = res.data.devicename;
						this.tformVal.merchant = res.data.clientKey;
						this.tformVal.model = res.data.model;

					},
					""
				);
			},
			setCard(data) {
				this.config = {
					title: this.$t("terminal.device_name") + ": " + data.devicename,
					rd1: [{
							tt: this.$t("terminal.device_sn"),
							ct: data.deviceid
						},
						{
							tt: this.$t("terminal.device_model"),
							ct: data.model
						},
						{
							tt: this.$t("terminal.network_type"),
							ct: data.terminalVersion
						},
						{
							tt: this.$t("terminal.app_distributor"),
							ct: data.agentName
						}
					],
					rd2: [{
							tt: this.$t("terminal.device_model_2"),
							ct: data.productName
						},
						{
							tt: this.$t("terminal.device_ip_address"),
							ct: data.ipaddress
						},
						{
							tt: this.$t("terminal.bound_merchant"),
							ct: data.merchantname ? data.merchantname : this.$t("terminal.unbound_merchant")
						}
					],
					rd3: [{
							tt: this.$t("terminal.cumulative_broadcast"),
							ct: data.totalOrder
						},
						// {tt: '累计收款', ct: data.totalPrice} 累计播报数量
						{
							tt: "",
							ct: ""
						}
					],
					testplay: () => {
						var deviceid = this.$route.query.deviceid;
						this.loading = true;
						this.$equipTestPlay(
							deviceid,
							data.productkey,
							res => {
								this.loading = false;
								if (res.errcode == 0) {
									this.$message.success(res.errmsg);
								} else {
									this.$message.error(res.errmsg);
								}
							},
							() => {
								this.loading = false;
							}
						);
					},
					edit: this.isEdit
				};
			},
			setBaseInfo(data) {
				this.baseInfo.createTime = data.createTime;
				this.baseInfo.activateTime = data.activateTime;
				this.baseInfo.lastOnlineTime = data.lastOnlineTime;
				this.baseInfo.lastOfflineTime = data.lastOfflineTime;
				this.baseInfo.volume = data.volume;
				this.baseInfo.hwVer = data.hwVer;
				this.baseInfo.appVer = data.appVer;
				this.baseInfo.sysAudioVer = data.sysAudioVer;
				this.baseInfo.usrAudioVer = data.usrAudioVer;
			},
			closeDia() {
				this.showDia = false;
				this.tform.deviceid = "";
				this.tform.productKey = "";
				this.tform.devicename = "";
				this.tform.merchant = "";
				this.tform.model = "";
			},
			submit() {
				this.$refs["ruleForm"].validate(valid => {
					if (valid) {
						this.okDia();
					}
				});
			},
			okDia() {
				//deviceId, devicename, productName, clientkey,
				this.$editEquip(
					this.tform.deviceid,
					this.tform.devicename,
					this.tform.model,
					this.tform.productKey,
					this.tform.merchant,
					res => {
						if (res.status == 200) {
							this.getDetail();
							this.closeDia();
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			setProCtr(vl) {
				var _this = this;
				this.editModel = {
					size: "middle",
					isbatch: false,
					value: vl ? vl : "",
					callback: vl => {
						_this.tform.productKey = vl;
					}
				};
			},
			setMcCtr(vl) {
				var _this = this;
				this.editMc = {
					// type:'0',
					size: "",
					vlkey: "clientKey",
					value: vl ? vl : "",
					callback: vl => {
						_this.tform.merchant = vl;
					}
				};
			}
		},
		mounted() {

			var _this = this;
			this.pconfig = {
				callback: page => {
					///
					_this.page = page;
					_this.getDetail();
				}
			};

			this.prconfig = {
				ctype: "0", ///// 0 eq 1 bcstore
				dvid: this.$route.query.deviceid,
				mcid: this.$route.query.merchantId
			};
			this.getDetail();
		}
	};
</script>
